// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../fe-workerportal/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-2fdc337e] .b-table-sticky-header>.table{border:1px solid #dee2e6}[data-v-2fdc337e] .b-table-sticky-header>.table.b-table>thead>tr>th{outline-color:#dee2e6;outline-style:solid;outline-width:1px;border:none}", ""]);
// Exports
module.exports = exports;
